import { render, staticRenderFns } from "./ImportApp.vue?vue&type=template&id=baf5892a&scoped=true"
import script from "./ImportApp.vue?vue&type=script&lang=js"
export * from "./ImportApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf5892a",
  null
  
)

export default component.exports